export const COLORS = {
  BACKGROUND: '#1A2660', // rgb(26, 38, 96)
  BACKGROUND_NEW:'#0b1339',
  TEXT: '#0E254D',
  PRIMARY: '#FF6E00', // rgb(  255, 110, 0)
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  TRANSPARENT: 'transparent',
  RED_LIGHT: '#F08080',
  RED: '#FF0000',
  DARK_GREY: '#2F2F2F',
  LIGHT_GRAY: '#EDEFF0',
  MEDIUM_GRAY: '#8A94A6',
  SIDEBAR_GRAY: '#222222',
  VHC_GRAY: '#3E3E3E',
  SELECTED: '#d0d3d6',
  TOAST_SUCCESS: 'rgba( 255, 110, 0, .8)',
  TOAST_ERROR: '#FC7777',
  GREEN: '#0A931A',
  REPORT_BLUE: '#0B2545',
  DARK_BLUE: '#0b1339'
};
